/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Transaction
 * @export
 * @interface ApiTransaction
 */
export interface ApiTransaction {
    /**
     * External unique transaction ID
     * @type {string}
     * @memberof ApiTransaction
     */
    id: string;
    /**
     * Transaction attributes key value pair
     * @type {{ [key: string]: string; }}
     * @memberof ApiTransaction
     */
    attributes?: { [key: string]: string; };
    /**
     * 
     * @type {Date}
     * @memberof ApiTransaction
     */
    createdTime?: Date;
    /**
     * External unique person ID
     * @type {string}
     * @memberof ApiTransaction
     */
    readonly personId?: string;
}

/**
 * Check if a given object implements the ApiTransaction interface.
 */
export function instanceOfApiTransaction(value: object): value is ApiTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ApiTransactionFromJSON(json: any): ApiTransaction {
    return ApiTransactionFromJSONTyped(json, false);
}

export function ApiTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
        'personId': json['personId'] == null ? undefined : json['personId'],
    };
}

export function ApiTransactionToJSON(json: any): ApiTransaction {
    return ApiTransactionToJSONTyped(json, false);
}

export function ApiTransactionToJSONTyped(value?: Omit<ApiTransaction, 'personId'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'attributes': value['attributes'],
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
    };
}

